/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ReceiptsListResponse,
  FetchReceiptsPayload,
  DownloadReceiptResult,
  DownloadReceiptPayload,
} from './types';
import { apiClient } from '@/utils/apiClient';
import { toQS } from '@/utils/toQS';

export const fetchReceipts = createAsyncThunk<
  ReceiptsListResponse,
  FetchReceiptsPayload | undefined,
  { rejectValue: string }
>('payments/receipts/fetch', async (payload, { rejectWithValue }) => {
  try {
    const qs = toQS(
      payload as
        | Record<string, string | number | boolean | null | undefined>
        | undefined
    );
    const res = await apiClient(`/payments/api/v1/receipts/${qs}`, {
      method: 'GET',
    });
    return res as ReceiptsListResponse;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load receipts';
    return rejectWithValue(String(msg));
  }
});

export const downloadReceiptFile = createAsyncThunk<
  DownloadReceiptResult,
  DownloadReceiptPayload,
  { rejectValue: string }
>(
  'payments/receipts/downloadFile',
  async ({ receipt_id }, { rejectWithValue }) => {
    if (!receipt_id) return rejectWithValue('receipt_id is required');

    try {
      const response = await apiClient(
        `/payments/api/v1/receipts/${encodeURIComponent(receipt_id)}/download/`,
        {
          method: 'GET',
        }
      );

      const data = response as any;

      if (data?.file_url) {
        return {
          file_url: data.file_url,
          number: data.number,
          created_at: data.created_at,
          id: data.id,
        };
      }

      return rejectWithValue('No file URL found in response');
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to download receipt file';
      return rejectWithValue(String(msg));
    }
  }
);
